import styled from 'styled-components';
import appTheme from 'theme-config';
import type { ReactNode } from 'react';
import { Loader } from 'semantic-ui-react';

const Wrapper = styled.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100vh',
  backgroundColor: appTheme.splash.backgroundColor,
  gap: '24px',
});

const AppName = styled.span({
  fontSize: '1.5rem',
  fontWeight: 600,
  color: appTheme.palette.headingText,
  letterSpacing: '0.02em',
});

const FullScreenLoader = (): ReactNode => (
  <Wrapper>
    <AppName>PaymentIQ</AppName>
    <Loader active inline="centered" size="medium" />
  </Wrapper>
);

export default FullScreenLoader;
